import { FormLabel, Typography, styled } from '@mui/material';

export const CountingText = styled(Typography)`
  color: #79767d;
  font-size: 14px;
  font-weight: 500;
  span {
    font-size: 16px;
    color: #5546a9;
  }
`;

export const ListTitleText = styled(Typography)`
  font-weight: 700;
  font-size: 18px;
`;

export const ListSubTitleText = styled(Typography)`
  font-size: 14px;
  font-weight: 500;
  color: #48464c;
`;

export const ListContentText = styled(Typography)`
  font-size: 12px;
  color: #605d64;
`;

export const ListSubContentText = styled(Typography)`
  color: #938f96;
  font-size: 12px;
`;

export const Title = styled(Typography)`
  font-weight: 700;
  font-size: 18px;
  color: #000;
  margin-bottom: 10px;
`;

export const IconLabel = styled(Typography)`
  color: #1d1b20;
  font-size: 14px;
  font-weight: 600;
`;

export const InspectionTitle = styled(Typography)`
  color: #000;
  font-size: 22px;
  font-weight: 700;
  line-height: 100%;
  text-align: center;
`;

export const FormLabelText = styled(FormLabel)`
  color: #1d1b20;
  font-size: 16px;
  font-weight: 500;
  span {
    color: #db2828;
  }
  margin-bottom: 8px;
`;

export const FormTitle = styled(Typography)`
  color: #1d1b20;
  font-size: 20px;
  font-weight: 700;
  line-height: 100%;
`;

export const DetailInfoText = styled(Typography)`
  color: #938f96;
  font-size: 16px;
  font-weight: 500;
`;

export const SubTitle = styled(Typography)`
  color: #79767d;
  font-size: 16px;
  font-weight: 500;
  line-height: 100%;
`;

export const MobileTitle = styled(Typography)`
  color: #1d1b20;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
`;

export const SelectHelperText = styled(Typography)`
  color: #db2828;
  line-height: 1.5;
  font-size: 0.75rem;
  font-weight: 400;
  text-align: left;
  margin-top: 3px;
  margin-right: 14px;
  margin-bottom: 0;
  margin-left: 14px;
`;
